









































































































































































































































































import {
  Vue,
  Prop,
  Component,
} from "@/shared/vuepack";
import {
  DrivewealthEnrollmentDraft,
  DrivewealthWizardStep
} from "@/shared/types";
import { Validator } from "vee-validate";
import * as drivewealth from "@/shared/custodianSettings/drivewealthTypes";
import { countries } from "./countries";
import WizardNavigation from "@/employee/components/investments/drivewealth/wizard/WizardNavigation.vue";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";

@Component({
  components: {
    WizardNavigation,
  }
})
export default class RequiredDisclosures extends Vue {
  @Prop()
  isSavingAccountClaims: boolean;

  $validator: Validator;
  countries = countries;

  drivewealthWizardStore = useDrivewealthWizardStore();

  employmentStatusContainer = drivewealth.employmentStatusFactory();
  jobSectorContainer = drivewealth.jobSectorFactory();
  occupationContainer = drivewealth.occupationFactory();

  mounted () {
    if (this.drivewealthWizardStore.draftIsDirty) {
      this.validate();
    }
    if (this.isSavingAccountClaims && !this.hasSignatureContent) {
      this.drivewealthWizardStore.clearEnrollmentData({});
    }
  }

  validate () {
    this.$validator
        .validate();
  }

  tryAdvance () {
    this.$validator
        .validate()
        .then(isValid => {
          if (isValid) {
            this.drivewealthWizardStore.setWizardStepComplete(this.wizardStep);
          }
        });
  }

  get wizardStep () {
    return DrivewealthWizardStep.RequiredDisclosures;
  }

  get employmentStatus () {
    return this.drivewealthWizardStore.disclosureEmploymentStatus;
  }

  set employmentStatus (value: drivewealth.EmploymentStatus) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "employmentStatus", value });
  }

  get isRequiredSectorAndOccupation () {
    return this.drivewealthWizardStore.disclosureEmploymentStatus === "EMPLOYED" ||
        this.drivewealthWizardStore.disclosureEmploymentStatus === "SELF_EMPLOYED";
  }

  get jobSector () {
    return this.drivewealthWizardStore.disclosureEmploymentType;
  }

  set jobSector (value: drivewealth.JobSector) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "employmentType", value });
  }

  get occupation () {
    return this.drivewealthWizardStore.disclosureOccupation;
  }

  set occupation (value: drivewealth.Occupation) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "occupation", value });
  }

  get citizenship () {
    return this.drivewealthWizardStore.disclosureCitizenship;
  }

  set citizenship (value: string) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "citizenship", value });
  }

  get isBroker () {
    return this.drivewealthWizardStore.disclosureIsBroker;
  }

  set isBroker (value: boolean) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "isBroker", value });
  }

  get isDirectorOrOwner () {
    return this.drivewealthWizardStore.disclosureIsDirector;
  }

  set isDirectorOrOwner (value: boolean) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "isDirector", value });
  }

  get directedCompany () {
    return this.drivewealthWizardStore.disclosureDirectedCompany;
  }

  set directedCompany (value: string) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "directedCompany", value });
  }

  get isPoliticallyAffiliated () {
    return this.drivewealthWizardStore.disclosureIsPoliticallyExposed;
  }

  set isPoliticallyAffiliated (value: boolean) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "isPoliticallyExposed", value });
  }

  get politicallyExposedNames () {
    return this.drivewealthWizardStore.disclosurePoliticallyExposedNames;
  }

  set politicallyExposedNames (value: string) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "politicallyExposedNames", value });
  }

  get hasSignatureContent () {
    return this.drivewealthWizardStore.hasSignatureContent;
  }

  get annualIncome () {
    return this.drivewealthWizardStore.disclosureAnnualIncome;
  }

  set annualIncome (value: number) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "annualIncome", value });
  }

  get annualIncomeValidator () {
    return {
      required: true,
      decimal: 2,
      min_value_usd: 1,
    };
  }

  selectState (veeValidateName: string) {
    return this.errors.has(veeValidateName) ? false : null;
  }
}
